"use client";

import {
  AccordionDetails,
  AccordionSummary,
  Typography,
  Tooltip,
  IconButton,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import InfoIcon from "@mui/icons-material/Info";
import { useEditDialog } from "../Providers/EditDialogContext";
import SpeakerOrganizationSelect from "@/app/(app)/search/(video)/SearchDrawer/SpeakerFilters/SpeakerOrganizationSelect";
import SpeakerSelect from "@/app/(app)/search/(video)/SearchDrawer/SpeakerFilters/SpeakerSelect";
import SpeakerTitleSelect from "@/app/(app)/search/(video)/SearchDrawer/SpeakerFilters/SpeakerTitleSelect";
import { CampaignType } from "@/interfaces/campaign";
import ClientAccordion from "@/stories/SearchDrawerComponents/ClientAccordion";

export default function SpeakerDrawer() {
  const { campaignType } = useEditDialog();

  // Only show speaker filters for video campaigns
  const isVideoCampaign = campaignType
    ? campaignType === CampaignType.Video
    : true; // Default to true while loading

  if (!isVideoCampaign) {
    return null;
  }
  return (
    <ClientAccordion
      openProperties={[
        "voice_ids",
        "title_search_terms",
        "organization_search_terms",
      ]}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography component="span" className="font-medium">
          Speaker
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <div className="flex flex-col gap-6">
          <Typography className="text-sm text-neutral-900 flex items-center gap-1">
            Filter your results by speakers
            <Tooltip title="Click to learn more about how search works!">
              <IconButton
                size="small"
                href="https://help.cloverleaf.ai/knowledge-base/how-does-search-work"
                target="_blank"
                rel="noopener noreferrer"
                className="text-neutral-500 hover:text-neutral-700"
              >
                <InfoIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Typography>
          <SpeakerSelect />
          <SpeakerTitleSelect />
          <SpeakerOrganizationSelect />
        </div>
      </AccordionDetails>
    </ClientAccordion>
  );
}
